<template>
    <form class="chat-head__search" @submit.prevent="search">

        <div class="search-controls">
            <img
                :src="env.public_base + '/assets/images/cross-icon.svg'"
                @click="removeFoundMessages"
                alt=""
                v-if="value !== ''"
                class="search-buttons"
            >
            <p v-if="show">{{Object.keys(searchMessages).length !== 0 ? counter : 0 }} / {{Object.keys(searchMessages).length}}</p>

            <button type="button"
                    @click="prevItem"
                    :disabled="counter == 1"
                    v-if="Object.keys(searchMessages).length !== 0 && show"
                    class="search-buttons search-buttons--up">
                <img :src="env.public_base + '/assets/images/button-down-icon.svg'" alt=""
            >
            </button>
            <button
                    type="button"
                    @click="nextItem"
                    :disabled="Object.keys(searchMessages).length == counter"
                    v-if="Object.keys(searchMessages).length !== 0 && show"
                    class="search-buttons"
            >
                <img :src="env.public_base + '/assets/images/button-down-icon.svg'" alt="">
            </button>
        </div>

        <label class="search__label" for=""></label>
        <input class="search__input" v-model="value" @change="checkContent" type="text" :placeholder="$t('search')">
        <button class="search__button">
            <img :src="env.public_base + '/assets/images/search-icon.svg'" alt="">
        </button>
    </form>
</template>

<script>
    import env from '../../env';
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                env,
                value: '',
                counter: 0,
                show: false,
                changed: false,
                counterStart: false,
            }
        },
        computed: {
            ...mapGetters(['searchMessages', 'messages', 'channel', 'channelId']),
        },
        methods: {
            removeFoundMessages() {
                this.value = '';
                this.counter = 0;
                this.counterStart = false;
                this.show = false;
                this.$store.commit('SET_SEARCH_MESSAGES', {});

                let idLte = Object.entries(this.messages)[Object.keys(this.messages).length - 1][1].id;
                if (idLte !== undefined) {
                    let params = {
                        'channel_id': this.channel.id,
                        'query': {
                            'offset': 0,
                            'limit': 10,
                            'id__lte': Object.entries(this.messages)[Object.keys(this.messages).length - 1][1].id,
                            'lang': localStorage.getItem('language')
                        },
                    };
                    this.$store.dispatch('channel_messages', params);

                    this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'scrollable', value: true});
                }
            },
            search() {
                if(this.value === '') return;

                if (!!Object.keys(this.messages).length) {
                    let params = {
                        'channel_id': this.channel.id,
                        'q': this.value,
                        'lang': localStorage.getItem('language')
                    };

                    this.counter = 0;
                    this.show = true;
                    this.$store.dispatch('search', params);

                    this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'scrollable', value: false});
                }
            },
            prevItem() {
                if(this.counter == 0) return;
                this.counter--;

                this.$store.commit('CLEAR_MESSAGES');
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'scrollable', value: false});

                let params = {
                    'channel_id': this.$route.params.id,
                    'query': {
                        'offset': 0,
                        'limit': 10,
                        'id__gte': Object.entries(this.searchMessages)[this.counter - 1][1].id,
                        'lang': localStorage.getItem('language')
                    },
                };
                this.$store.dispatch('channel_messages', params);

                if(this.counter <= 0) this.counter = 1;
            },
            nextItem() {
                if(this.counter >= Object.keys(this.searchMessages).length && Object.keys(this.searchMessages).length !== 0 && this.counterStart) return;

                this.$store.commit('CLEAR_MESSAGES');

                let params = {
                    'channel_id': this.$route.params.id,
                    'query': {
                        'offset': 0,
                        'limit': 10,
                        'id__gte': Object.entries(this.searchMessages)[this.changed ? this.counter - 1 : this.counter][1].id,
                        'lang': localStorage.getItem('language')
                    },
                };

                if(this.$route.name === 'personal-channel') {
                    params['channel_id'] = this.channelId;
                }

                this.$store.dispatch('channel_messages', params);
                const mainChatSection = document.getElementById("main-chat-section");
                mainChatSection.scrollTop = 1;
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'scrollable', value: false});

                this.changed ? this.counter : this.counter++;
                this.counterStart = true;
                this.changed = false;
            },
            checkContent() {
                if (this.value == '') this.show = false;
            }
        }
    }
</script>

<style lang="scss">

    .search-controls {
        display: flex;
        align-items: center;

        * {
            margin: 0 10px;
            white-space: nowrap;
        }
    }

    .search-buttons {
        cursor: pointer;
        background-color: transparent;
        padding: 0;

        img {
            margin: 0;
        }
        &:disabled:hover {
            opacity: 1;
        }
    }
    .search-buttons--up {
        transform: rotate(180deg)
    }

</style>
